import * as React from 'react'
import * as ReactDOM from 'react-dom'
import {App} from '@/components/app'
import '@/themes/one-dark/index.less'
import '@/themes/citrine/main.less'

ReactDOM.render(
  <App/>,
  document.getElementById('app')
)
